export default __webpack_public_path__ + "static/media/45.d793088c.png";